import { EdelError } from "@adapters/infrastructures/interfaces/errors";
import { IHoldingReportData } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import { IUnderstandSectionData } from "@domains/aggregates/interfaces/Reports/iUnderstandSection";
import { DPTranactionMainEntity } from "@domains/entities/interfaces/Reports/HoldingReport/iDPTransactionHistory";
import { IErrorActions, IErrorData } from "../IError";
import { DropDownEntity } from "@/components/Reports/CommonComponent/constant";
import { IHoldingDetailsEntity } from "@domains/entities/interfaces/Reports/HoldingReport/iHoldingDetails";

export interface IHoldingReportsAction {
  type: string;
  payload: IHoldingReportsData;
  errorType?: HoldingErrorEnum;
}
export enum HoldingErrorEnum {
  ERROR_DATA = "errorData",
  DOWNLOADSTATUS = "downloadStatus",
  EMAILSTATUS = "emailStatus",
  DP_TRANSACTION_ERROR_DATA = "dpTransactionHistoryErrorData",
  DP_TRANSACTION_SUBMIT_ERROR_DATA = "dpTransactionSubmitErrorData",
}
export interface IHoldingReportsData {
  data?: IHoldingReportData;
  loader?: boolean;
  errorData?: { error: EdelError; isOpen: boolean };
  dpTransactionHistoryErrorData?: { error: EdelError; isOpen: boolean };
  dpTransactionSubmitErrorData?: { error: EdelError; isOpen: boolean };
  emptyValidation?: { icon: string; message: string };
  emptyDpTransaction?: { icon: string; message: string };
  dpTransactionEntity?: DPTranactionMainEntity;
  dpTransactionMainLoader?: boolean;
  dpTransactionLoader?: boolean;
  prodDropDown?: DropDownEntity;
  smtf?: boolean;
  HoldingDetails?: Map<string, IHoldingDetailsEntity>;
}

export interface IMarketStatusStreamEntity {
  status: IMarketStatusExchanges;
  lut: string;
}
export interface IMarketStatusExchanges {
  BFO: string;
  NFO: string;
  BSE: string;
  NSE: string;
  NCDX: string;
  MCX: string;
  CDS: string;
  [key: string]: string;
}
export interface IStreamEntity {
  symbol?: string;
  curPrice?: string;
  changePrice?: string;
  changePercentage?: string;
  updatedTime?: string;
  marketStatus?: string;
  oiChange?: string;
  oiChangePercentage?: string;
  volume?: string;
  volumeChange?: string;
  volumeChangePercentage?: string;
  openInterest?: string;
  high?: string;
  low?: string;
  futurePrice?: string;
  spotPrice?: string;
  bid?: string;
  ask?: string;
  iv?: string;
  open?: string;
  close?: string;
  rollOver?: string;
  rollOverCost?: string;
  rollOverCostPercentage?: string;
  totalTradedValue?: string;
  bidQty?: string;
  askQty?: string;
  avgTradedPrice?: string;
  premiumDiscount?: string;
  mcap?: string;
  hCL?: string;
  lCL?: string;
  "1D_ChangePrice"?: string;
  "1D_ChangePercentage"?: string;
  "1WK_ChangePrice"?: string;
  "1WK_ChangePercentage"?: string;
  "1MN_ChangePrice"?: string;
  "1MN_ChangePercentage"?: string;
  "3MN_ChangePrice"?: string;
  "3MN_ChangePercentage"?: string;
  "6MN_ChangePrice"?: string;
  "6MN_ChangePercentage"?: string;
  "1YR_ChangePrice"?: string;
  "1YR_ChangePercentage"?: string;
}

export interface ITradeUpdate {
  pTyp: string;
  rQty: string;
  tQty: string;
  fQty: string;
  dQty: string;
  oID: string;
}

export enum EmptyIcon {
  EMPTY = "empty",
  SEARCH = "search",
  FILTER = "filter",
  ERROR = "error",
  SEARCH_NEW = "search_new",
  ERROR_EXCLA = "error_exla",
}

export enum StockDetailsEnum {
  OVERVIEW = "overview",
  TRANSACTION = "transaction",
}

export interface IHoldingReportsActions extends IErrorActions {
  getHoldingReportData(HoldingReportEntityList: IHoldingReportData): void;
  getUnderstandingSectionData(
    understandSectionData: IUnderstandSectionData,
  ): void;
  setHoldingLoader(loader: boolean): void;
  setErrorUnderStandings(payload: IErrorData): void;
  hideUnderstandingError(): void;
  setEmptyValidation(emptyValidation: IHoldingReportsData): void;
  setEmptyDPValidation(emptyDPValidation: IHoldingReportsData): void;
  hideEmptyValidation(): void;
  hideDPEmptyValidation(): void;
  toggleDpTransactionLoader(loader: boolean): void;
  toggleDpTransactionMainLoader(loader: boolean): void;
  setDpTransactionHistory(dpTransactionEntity: DPTranactionMainEntity): void;
  getDpIds(dpTransactionEntity: DPTranactionMainEntity): void;
  saveProdAssetDropDown(prodAssetFilter: DropDownEntity): void;
  saveSMTF(smtf: boolean): void;
  getHoldingReportDataQty(
    HoldingDetails: Map<string, IHoldingDetailsEntity>,
  ): void;
}
